import SaleExpenseForm from "../../SaleExpense/SaleExpenseForm";

const QuickSaleForm = () => {
  return <SaleExpenseForm type="in" />;
};
export default QuickSaleForm;
